const PaginaTeste = () => {
  const url = "https://firebasestorage.googleapis.com/v0/b/igrejasaopedroapp.appspot.com/o/page%2Fpaginateste.html?alt=media&token=d114c5a1-93a2-4369-afe6-078628db0ea3";

  return (<></>
    // <iframe
    //   src={url}
    //   title="PaginaTeste"
    //   style={{
    //     position: "fixed",
    //     top: 0,
    //     left: 0,
    //     width: "100vw",
    //     height: "100vh",
    //     border: "none",
    //     zIndex: 9999
    //   }}
    // />
  );
};


export default PaginaTeste;